/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const LinkIcon = /*#__PURE__*/ createSvgIcon(
  'LinkIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M6 14c-1.107 0-2.05-.39-2.83-1.171C2.39 12.047 2 11.102 2 9.995s.39-2.05 1.17-2.828C3.95 6.389 4.893 6 6 6h2.25c.213 0 .39.071.534.214A.72.72 0 019 6.746c0 .21-.072.39-.216.535a.72.72 0 01-.534.219H6a2.41 2.41 0 00-1.77.73A2.41 2.41 0 003.5 10c0 .694.243 1.285.73 1.77.485.487 1.076.73 1.77.73h2.25c.213 0 .39.072.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535A.72.72 0 018.25 14H6zm1.756-3.25a.738.738 0 01-.537-.214.714.714 0 01-.219-.532c0-.21.072-.39.215-.535a.72.72 0 01.534-.219h4.495c.212 0 .391.071.537.214.146.143.219.32.219.532 0 .21-.072.39-.215.535a.719.719 0 01-.534.219H7.756zM11.75 14a.728.728 0 01-.534-.214.72.72 0 01-.216-.532c0-.21.072-.39.216-.535a.72.72 0 01.534-.219H14c.694 0 1.285-.243 1.77-.73.487-.485.73-1.076.73-1.77s-.243-1.285-.73-1.77A2.41 2.41 0 0014 7.5h-2.25a.728.728 0 01-.534-.214.72.72 0 01-.216-.532c0-.21.072-.39.216-.535A.72.72 0 0111.75 6H14c1.107 0 2.05.39 2.83 1.171.78.781 1.17 1.726 1.17 2.834s-.39 2.05-1.17 2.828C16.05 13.611 15.107 14 14 14h-2.25z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default LinkIcon;
